import { render, staticRenderFns } from "./mediaDetail.vue?vue&type=template&id=1925cd4e&scoped=true&"
import script from "./mediaDetail.vue?vue&type=script&lang=js&"
export * from "./mediaDetail.vue?vue&type=script&lang=js&"
import style0 from "./mediaDetail.vue?vue&type=style&index=0&id=1925cd4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1925cd4e",
  null
  
)

component.options.__file = "mediaDetail.vue"
export default component.exports